import { useParams } from 'next/navigation';
import { Order } from 'shared/types/cart/Order';
import { Money } from 'shared/types/product/Money';
import Typography from 'components/gruenland/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { useFormat } from 'helpers/hooks/useFormat';
import OrderItemsList from '../../order-items-listing/OrderItemsList';

type Props = {
  order: Order;
};

const ThankyoupageOrderSummary: React.FC<Props> = ({ order }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { locale } = useParams();

  const summaryInfo: Array<{ label: string; value?: Money }> = [
    {
      label: formatMessage({ id: 'summary.subtotal', defaultMessage: 'Subtotale' }),
      value: order.sum,
    },
    {
      label: formatMessage({ id: 'summary.discount', defaultMessage: 'Sconto' }),
      value: order.sum,
      //value: order.shippingInfo?.discounts,
    },
    {
      label: formatMessage({ id: 'summary.shipping', defaultMessage: 'Spedizione' }),
      value: order.shippingInfo?.price,
    },
    {
      label: formatMessage({ id: 'summary.taxes', defaultMessage: 'Tasse' }),
      value: order.taxed?.taxAmount,
    },
  ];

  return (
    <div className="grow bg-white px-4 md:px-6 lg:p-9">
      <div className="my-4 md:mb-0 md:border-b md:border-neutral-400 md:pb-4 md:text-[18px] lg:m-0 lg:border-b-0 lg:pb-7">
        <Typography as="h4" asSkeleton={!order.sum} className="w-fit text-[18px] leading-[20px] text-primary-black">
          {formatMessage({ id: 'order.details', defaultMessage: 'Dettagli ordine' })}
        </Typography>
      </div>

      <OrderItemsList lineItems={order.lineItems || []} />

      {/* Order summary info */}
      <div className="grid gap-2 border-t border-neutral-400 bg-white py-4 lg:pt-8">
        {summaryInfo.map(({ label, value }, index) => {
          if ((value?.centAmount && value.centAmount > 0 && !!order.sum) || !order.sum)
            return (
              <div key={index} className="flex items-center justify-between">
                <Typography asSkeleton={!order.sum} className="text-[14px] text-primary-black md:text-[16px]">
                  {label}
                </Typography>
                <Typography asSkeleton={!order.sum} className="text-[14px] text-primary-black md:text-[16px]">
                  {CurrencyHelpers.formatForCurrency(value ?? 99999, locale)}
                </Typography>
              </div>
            );
        })}

        <div className="mt-4 flex items-center justify-between lg:mt-3 lg:border-t lg:border-neutral-400 lg:pt-3">
          <Typography
            asSkeleton={!order.sum}
            className="font-medium text-primary-black md:text-[18px] lg:leading-loose"
          >
            {formatMessage({ id: 'summary.total', defaultMessage: 'Totale' }) + ':'}
          </Typography>
          <Typography
            asSkeleton={!order.sum}
            className="font-medium text-primary-black md:text-[18px] lg:leading-loose"
          >
            {CurrencyHelpers.formatForCurrency(order?.sum ?? 999999, locale)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ThankyoupageOrderSummary;
